const mouseSelection = "_mouseSelection_1p43j_1";
const styles = {
  mouseSelection
};
export {
  styles as default,
  mouseSelection
};
